export class PostEventListener {
    constructor(onMessage: (event: MessageEvent)=>void) {
        window.addEventListener('message', onMessage);
    }
}